import { FC } from 'react';
import { OverlayContainer, AlertIcon } from './BatteryAlertOverlay.styles';

interface BatteryAlertOverlayProps {
  isVisible: boolean;
  isBlinking: boolean;
}

export const BatteryAlertOverlay: FC<BatteryAlertOverlayProps> = ({
  isVisible,
  isBlinking,
}) => {
  if (!isVisible) return null;

  return (
    <OverlayContainer $isBlinking={isBlinking}>
      <AlertIcon>⚠️</AlertIcon>
      Por favor Conecte o carregador para carregar o tablet
      <AlertIcon>⚠️</AlertIcon>
    </OverlayContainer>
  );
};
